<div *ngFor="let documentGroup of groupedDocuments" class="category">
  <h2 *ngIf="documentGroup.category">{{ documentGroup.category.name }}</h2>
  <div *ngFor="let asset of documentGroup.assets" class="links">
    <a *ngIf="asset.file" href="{{ asset.file.url }}"><i class="fa-light fa-download"></i>{{ asset.name }}</a>
  </div>
</div>
